/**
 * Hands a built document to the browser as a download.
 *
 * The object URL is revoked straight after: each one pins its blob in memory
 * until it is, and a reader exporting repeatedly would accumulate them. Both
 * the dashboard and its comparison export, so the revoke lives in one place
 * rather than being remembered twice.
 *
 * @param {string} filename - Name to save under.
 * @param {string} content - The document.
 */
export const downloadCsv = (filename, content) => {
  const url = URL.createObjectURL(
    new Blob([content], { type: 'text/csv;charset=utf-8;' })
  );
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
